import { createSelector } from 'reselect';
import { createReducer } from '@mews/framework';
import { CLOSE_APP_SIDEBAR, OPEN_APP_SIDEBAR } from './actions';
import { moduleSelector } from './module';

interface AppSidebarState {
    isAppSidebarOpened: boolean;
}

const initialState: AppSidebarState = {
    isAppSidebarOpened: false,
};

export default createReducer(initialState, {
    [OPEN_APP_SIDEBAR]: (state: AppSidebarState) => ({ ...state, isAppSidebarOpened: true }),
    [CLOSE_APP_SIDEBAR]: (state: AppSidebarState) => ({ ...state, isAppSidebarOpened: false }),
});

export const isAppSidebarOpened = createSelector(moduleSelector, (state: AppSidebarState) => state.isAppSidebarOpened);
